<template>
  <b-modal
    id="modalDetailsContrato"
    title="Detalhes do Contrato"
    title-class="font-18"
    hide-footer
    no-close-on-backdrop
    @hidden="$emit('closeModal')"
  >
    <div class="row">
      <div class="col-sm-12">
        <p><strong>Nome: </strong>{{ contrato.codigo }}</p>
      </div>
      <div class="col-sm-12">
        <p><strong>Descrição: </strong>{{ contrato.description }}</p>
      </div>
      <div class="col-sm-12">
        <p><strong>Valor: </strong>{{ moneyToCurrencyBr(contrato.value) }}</p>
      </div>
      <div class="col-sm-12">
        <p>
          <strong>Status: </strong>
          <span v-html="statusContratoTranslate(contrato.status)"></span>
        </p>
      </div>
      <div class="col-sm-12">
        <p>
          <strong>Criado por:</strong>
          {{ createdUpdatedUser(contrato.createdBy, contrato.createdAt) }}
        </p>
      </div>
      <div class="col-sm-12">
        <p>
          <strong>Atualizado por:</strong>
          {{ createdUpdatedUser(contrato.updatedBy, contrato.updatedAt) }}
        </p>
      </div>
    </div>
    <div class="modal-footer-custom">
      <button
        type="button"
        class="btn btn-secondary"
        title="Fechar"
        @click="$emit('closeModal')"
      >
        Fechar
      </button>
    </div>
  </b-modal>
</template>

<script>
import {
  createdUpdatedUser,
  statusContratoTranslate,
  moneyToCurrencyBr,
} from '@/utils/strings'

export default {
  name: 'CreateEditContratoModal',

  props: {
    clientId: {
      type: String,
      required: true,
    },
    contratoId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      contrato: {},
      createdUpdatedUser,
      statusContratoTranslate,
      moneyToCurrencyBr,
    }
  },

  methods: {
    async getContrato() {
      try {
        this.contrato = await this.$store.dispatch('getContrato', {
          clientId: this.clientId,
          contratoId: this.contratoId,
        })
        this.$bvModal.show('modalDetailsContrato')
      } catch (error) {
        if (error && error.message) {
          this.$root.$bvToast.toast(error.message, {
            title: 'Atenção!',
            variant: 'warning',
            solid: true,
          })
        } else {
          this.$root.$bvToast.toast(
            'Não foi possível se conectar ao servidor.',
            {
              title: 'Erro!',
              variant: 'danger',
              solid: true,
            },
          )
        }
        this.$emit('closeModal', false)
      }
    },
  },

  mounted() {
    this.getContrato()
  },
}
</script>
